import * as v from 'valibot';
import { BaseIssue } from 'valibot';

import { vcOptionalWithNullToUndefined } from '../../utils/valibot/custom-types';
import { newSchema } from '../../utils/valibot/schema';

/**
 * Generates a Valibot schema for a branded value.
 * As this equals
 *
 * ```
 * export interface BrandedValue<T> {
 *   bmw?: T;
 *   mini?: T;
 * }
 * ```
 *
 * the schema needs to be generated dynamically based on the value schema.
 * @param valueSchema
 */
export function brandedValueSchema<T extends v.BaseSchema<unknown, unknown, BaseIssue<unknown>>>(valueSchema: T) {
  return newSchema(
    `BrandedValueSchema<?>`,
    v.object({
      bmw: vcOptionalWithNullToUndefined(valueSchema),
      mini: vcOptionalWithNullToUndefined(valueSchema),
    }),
  );
}

export const NextBestVehicleSchema = newSchema(
  'NextBestVehicleSchema',
  v.object({
    modelCode: v.string(),
    paint: v.optional(v.string()),
    fabric: v.optional(v.string()),
    imageUrl: v.optional(v.string()),
  }),
);

export const CustomerInsightsSchema = newSchema(
  'CustomerInsightsSchema',
  v.object({
    customerValueClass: vcOptionalWithNullToUndefined(v.number()),
    purchaseScoreClass: v.optional(brandedValueSchema(v.number())),
    bevScoreClass: vcOptionalWithNullToUndefined(v.number()),
    nextBestVehicles: v.optional(brandedValueSchema(v.array(NextBestVehicleSchema))),
    updateDate: v.optional(v.string()),
    marketGcid: v.optional(v.string()), // Seems to be a country 2 char code with the GCID which is a UUID: "US-123e4567-e89b-12d3-a456-426614174000"
  }),
);

export type NextBestVehicle = v.InferOutput<typeof NextBestVehicleSchema>;
export type CustomerInsights = v.InferOutput<typeof CustomerInsightsSchema>;
